import React from "react";
import { NoInternet } from "@utils/defaultImages";
import BackImg from "@assets/images/stepsBack.jpg";

const NoInternetConnection = () => {
  return (
    <div
      className="p-[20px] md:p-[100px] grid grid-cols-1 md:grid-cols-2 bg-cover rounded-xl"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="text-white flex flex-col justify-center">
        <h2 className="text-[20px] font-[600] font-[Lato]">
          Oops! That Didn’t Go as Planned
        </h2>
        <p className="text-[16px] font-[Lato] font-[500]">
          We’re optimizing things for you. Please check back in a moment.
        </p>
      </div>
      <div className="text-white flex justify-center mt-3">
        {" "}
        <NoInternet className="max-h-[376px] max-w-[265px]" />
      </div>
    </div>
  );
};

export default NoInternetConnection;
